module.exports={
    "development": {
        "EXIST_URL": "http://localhost:8080/exist/restxq/satni"
    },
    "production": {
        "EXIST_URL": "http://gtlab.uit.no:8082/exist/restxq/satni"
    }
}